import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { setAnalyticsEvent } from "../../core/helpers/analytics";

export default function StateCardBasic(props) {
  const history = useHistory();

  const redirect = () => {
    let eventName = '';
    if (props.state !== 'dashboard-rank'){

      if (props.cta === 'View KYC') {
        eventName = "Postlogin_orobonds_asset_View_KYC_clicked"
      } else if (props.cta === 'Complete your KYC') {
        eventName = "SIkycBannerClicked"
      }
      { process.env.REACT_APP_RENDER_GA === "true" &&
        setAnalyticsEvent(window.location.pathname + window.location.hash,eventName);
      }
        history.push({
          pathname: props.link,
      state: { ...props.userState, product: props?.product }, //this state is being used through location.state
      
    });
  }
  };
  const determineClassname = () => {
    let classname = 'd-flex state-banner-main ';
    if (props.state === 'failed') {
      classname += 'failedCss';
    } else if (props.state === "done") {
      classname += 'doneCss';
    } 
    else if (props.state === "pending") {
      classname += 'pendingCss';
    } 
    else if (props.state === 'dashboard-rank'){
      classname += 'dashboardrankCss'
    }
    return classname;
  }

  return (
      <>
        <div
          onClick={props.onClick ? props.onClick : redirect}
          // className="d-flex state-banner-main"
          className={determineClassname()}
        >
          {/* <div className="image-div">
            <img src={props.img} />
          </div> */}
          <div className="text-div">
            <p>{props.text1} {
              props.state === 'dashboard-rank' ?
              <span style={{textDecoration: "underline"}}>
              <a className="text-white" href={`${process.env.REACT_APP_URL_ENDPOINTS}/terms-of-use/`} target="_blank">
                {props.text2}</a></span> :
              <span style={{textDecoration: "underline"}}>
              {props.text2}</span>
            }
            </p>
          </div>
        </div>
      </> 
    );
}
